import type { IconData } from '@stacksjs/iconify-core'

export const contentLike: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4 0a4 4 0 0 1 4 4v1h8v3a8 8 0 0 1-8 8H4zM2.5 5H0v11h2.5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentLike
